import React, { Component } from 'react';
class CloseButton extends Component {
	render() {
		return (
			<svg width="42" height="41" viewBox="0 0 42 41"><title>closeButton</title><defs><filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="a"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/><feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/><feMerge><feMergeNode in="shadowMatrixOuter1"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs><g filter="url(#a)" transform="translate(5.287 3)" fill="none" fillRule="evenodd"><ellipse stroke="#4B5562" fill="#28759F" cx="15.86" cy="15.5" rx="15.86" ry="15.5"/><path fill="#FFF" d="M22.724 11.619L20.044 9l-4.078 3.986L11.888 9l-2.68 2.619 4.08 3.985-4.08 3.986 2.68 2.619 4.078-3.986 4.079 3.986 2.68-2.619-4.08-3.985z"/></g></svg>
		);
	}
}

export default CloseButton;


// WEBPACK FOOTER //
// ./app/components/Modals/CloseButton.jsx